import { createContext } from "react";

export interface AlertBannerContextValue {
  bannerHeightPx: number;
  bannerRef: (element: HTMLDivElement | null) => void;
}

export const AlertBannerContext = createContext<AlertBannerContextValue>({
  bannerHeightPx: 0,
  bannerRef: () => {},
});
